import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "n-page__filters" }
const _hoisted_2 = { class: "n-page__statistics" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__delimiter" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "n-page__tiles"
}
const _hoisted_5 = {
  key: 1,
  class: "page-items__container"
}
const _hoisted_6 = { class: "page__no-data-item label-m" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_SortDropdown = _resolveComponent("SortDropdown")!
  const _component_FilterSection = _resolveComponent("FilterSection")!
  const _component_ParticipantItem = _resolveComponent("ParticipantItem")!
  const _component_SelectableItem = _resolveComponent("SelectableItem")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_PageContentLayout = _resolveComponent("PageContentLayout")!

  return (_openBlock(), _createBlock(_component_PageContentLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_FilterSection, {
          filter: _ctx.module.filter,
          schemeSmall: _ctx.smallFilterLayout,
          schemeLarge: _ctx.bigFilterLayout
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Statistics, { module: _ctx.module }, null, 8, ["module"]),
              _hoisted_3,
              _createVNode(_component_SortDropdown, {
                items: _ctx.sortTypes,
                modelValue: _ctx.module.filter.current.ordering,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event))
              }, null, 8, ["items", "modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["filter", "schemeSmall", "schemeLarge"])
      ]),
      (_ctx.module.loaded && _ctx.items.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createBlock(_component_SelectableItem, {
                key: item.id,
                selected: _ctx.getIsSelectedItem(item.id),
                onSelect: ($event: any) => (_ctx.toggleSelectedItem(item.id))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ParticipantItem, {
                    item: item,
                    onSelect: ($event: any) => (_ctx.setCurrentAndShow(item))
                  }, null, 8, ["item", "onSelect"])
                ]),
                _: 2
              }, 1032, ["selected", "onSelect"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.module.loaded && !_ctx.items.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('common.no_data', 'f')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_InfiniteScroll, {
        filters: _ctx.module.filter.current,
        onLoadMore: _cache[1] || (_cache[1] = ($event: any) => (_ctx.module.append()))
      }, null, 8, ["filters"])
    ]),
    _: 1
  }))
}